import React, { useEffect, useState } from 'react';
import { BannerWrapper, Wrapper } from './styled';
import Layout from '../../components/Layout';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Pagination from '../../components/Pagination';
import { GetPosts, GetSeriesNum, GetTags } from '../../service/blog';
import {
	SkeletonBanner,
	SkeletonMoBanner,
	SkeletonPocket,
	SkeletonSeriesWrap,
} from '../../components/Skeleton';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
	seriresArrayAtom,
	seriresAtom,
	seriresNumAtom,
	shuffleAtom,
} from '../../atom/taxonomy';

const Pocket = () => {
	const pocket = [
		{
			banner: '/images/pocket01.png',
			mobanner: '/images/mo-pocket01.png',
			title: '보안',
			total: '게시글 17개',
		},
		{
			banner: '/images/pocket02.png',
			mobanner: '/images/mo-pocket02.png',
			title: '화상상담',
			total: '게시글 17개',
		},
		{
			banner: '/images/pocket03.png',
			mobanner: '/images/mo-pocket03.png',
			title: 'ESG',
			total: '게시글 17개',
		},
		{
			banner: '/images/pocket04.png',
			mobanner: '/images/mo-pocket04.png',
			title: '솔루션',
			total: '게시글 17개',
		},
		{
			banner: '/images/pocket05.png',
			mobanner: '/images/mo-pocket05.png',
			title: '리드앤라이트',
			total: '게시글 17개',
		},
		{
			banner: '/images/pocket06.png',
			mobanner: '/images/mo-pocket06.png',
			title: '포켓6',
			total: '게시글 17개',
		},
		{
			banner: '/images/pocket01.png',
			mobanner: '/images/mo-pocket01.png',
			title: '보안',
			total: '게시글 17개',
		},
		{
			banner: '/images/pocket02.png',
			mobanner: '/images/mo-pocket02.png',
			title: '화상상담',
			total: '게시글 17개',
		},
		{
			banner: '/images/pocket03.png',
			mobanner: '/images/mo-pocket03.png',
			title: 'ESG',
			total: '게시글 17개',
		},
		{
			banner: '/images/pocket04.png',
			mobanner: '/images/mo-pocket04.png',
			title: '솔루션',
			total: '게시글 17개',
		},
		{
			banner: '/images/pocket05.png',
			mobanner: '/images/mo-pocket05.png',
			title: '리드앤라이트',
			total: '게시글 17개',
		},
		{
			banner: '/images/pocket06.png',
			mobanner: '/images/mo-pocket06.png',
			title: '포켓6',
			total: '게시글 17개',
		},
	];

	const params = useParams();
	const [paged, setPaged] = useState(1);
	const postsPerPage = 8;
	const [items, setItems] = useState([]);
	const [s, setS] = useState(params?.keyword);
	const nav = useNavigate();
	const [total, setTotal] = useState(0);
	const [maxPaged, setMaxPaged] = useState(1);
	const [seriesNum, setSeriesNum] = useRecoilState(seriresNumAtom);
	const [shuffle, setShuffle] = useRecoilState(shuffleAtom);
	const series = useRecoilValue(seriresAtom);

	const [seriesArray, setSeriesArray] = useRecoilState(seriresArrayAtom);

	function shuffleArray(array) {
		const shuffledArray = [...array]; // Create a copy of the original array
		for (let i = shuffledArray.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[shuffledArray[i], shuffledArray[j]] = [
				shuffledArray[j],
				shuffledArray[i],
			];
		}
		return shuffledArray;
	}

	useEffect(() => {
		GetPosts({
			paged: 1,
			postsPerPage: 8,
			s: params?.keyword,
		})
			.then((res) => {
				console.log(res);
				if (res.data.code == 200) {
					setItems(res.data.body.items);
					setTotal(res.data.body.total);
					setMaxPaged(res.data.body.maxPaged);
				} else {
					setItems(null);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}, [params?.keyword]);

	const DoSearch = () => {
		if (s) {
			nav(`/s/${s}`);
		}
	};

	const DoEnter = (e) => {
		if (e.key === 'Enter') {
			DoSearch();
		}
	};

	const onPaging = (page) => {
		console.log(page);
		// router.push(
		// 	'/products/' +
		// 		(paged.category_ID ? paged.category_ID + '/' : '') +
		// 		'?paged=' +
		// 		page
		// );
		window.scrollTo(0, 0);
		// setItems(null);
		setPaged(page);
	};

	const [tags, setTags] = useState([]);

	useEffect(() => {
		GetTags({
			series: params?.ID,
		})
			.then((res) => {
				if (res.data.code == 200) {
					setTags(res.data.body.result);
				} else {
					setTags(null);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}, []);

	const [pockets, setPocket] = useState([]);

	const [c, setC] = useState([]);

	useEffect(() => {
		const shuffledObjects = shuffleArray(shuffle);
		setC(shuffleArray(seriesNum));
		console.log(77, shuffledObjects);
		setShuffle(shuffledObjects);
		GetSeriesNum({})
			.then((res) => {
				console.log(res);

				const sortedObjects = [...res.data.body.array]; // Create a copy of the array
				sortedObjects.sort((a, b) => b.value - a.value); // Sort by 'count' in ascending order

				console.log(123, sortedObjects);
				setSeriesNum(sortedObjects);
			})
			.catch((err) => {
				console.log(err);
			});
	}, []);

	const handleInputChange = (e) => {
		const searchTerm = e.target.value;
		console.log(seriesNum);

		const filteredData = seriesArray.filter((item) =>
			item.title.includes(searchTerm)
		);

		setSeriesNum(filteredData);
	};

	return (
		<Layout>
			<Wrapper>
				<div className="flex-wrapper">
					<div className="left">
						<div className="input-box">
							<img src="/images/icon-search01.svg" alt="" />
							<input
								onChange={handleInputChange}
								onKeyDown={DoEnter}
								type="text"
								value={s}
							/>
						</div>
						<div>
							{!seriesNum?.length ? (
								<div className="result">
									<div className="result-box">
										<p>
											검색 결과가 없어요
											<br /> 다른 키워드를 검색해보세요!
										</p>
									</div>
								</div>
							) : seriesNum?.length ? (
								<>
									<div className="total-box">
										<p>
											총 <span>{seriesNum?.length}</span>개의 포켓이 있습니다.
										</p>
									</div>
									<div className="pocket-wrap">
										<div onClick={() => console.log(series)}></div>
										<div className="pocket-list">
											{seriesNum?.length ? (
												seriesNum.map((item, key) => (
													<>
														<div
															className="pocket"
															key={key}
															style={{
																backgroundImage: `url(${shuffle[key]?.thumbnail})`,
															}}
															onClick={() => nav(`/blog/series/${item?.key}`)}
														>
															<h2>{item?.title}</h2>
															<p>게시글 {item?.value}개</p>
														</div>
														<div
															className="mo-pocket"
															style={{
																backgroundImage: `url(${shuffle[key]?.m})`,
															}}
															onClick={() => nav(`/blog/series/${item?.key}`)}
														>
															{/* <h2>{series[item?.key]?.title}</h2> */}
															<h2>{item?.title}</h2>
															<p>게시글 {item?.value}개</p>
														</div>
													</>
												))
											) : (
												<>
													{/* <SkeletonHomePocket />
													<SkeletonHomePocket />
													<SkeletonHomePocket />
													<SkeletonHomePocket />
													<SkeletonHomePocket />
													<SkeletonHomePocket /> */}
												</>
											)}

											{/* {series.map((item, key) => (
												<>
													<div
														className="pocket"
														key={key}
														style={{ backgroundImage: `url(${item.banner})` }}
													>
														<h2>{item.title}</h2>
														<p>{item.total}</p>
													</div>
													<div
														className="mo-pocket"
														style={{
															backgroundImage: `url(${item.mobanner})`,
														}}
													>
														<h2>{item.title}</h2>
														<p>{item.total}</p>
													</div>
												</>
											))} */}
										</div>
									</div>
								</>
							) : (
								<SkeletonPocket />
							)}
						</div>
						<Pagination
							total={seriesNum?.length}
							postsPerPage={12}
							paged={paged}
							maxPaged={1}
							onPaging={onPaging}
						/>
					</div>
					<div className="mo-banner-wrap">
						{seriesNum?.length ? (
							<div
								className="mo-banner"
								style={{ backgroundImage: `url(/images/mo-banner.png)` }}
							>
								<p className="title">
									새로운 금융IT 세상을 만들어갈 인재를 모십니다.
								</p>
								<a href="https://kbds.career.greetinghr.com/" target="_blank">
									<span>
										채용공고 보러가기
										<img src="/images/icon-banner-more.svg" alt="" />
									</span>
								</a>
							</div>
						) : (
							<SkeletonMoBanner />
						)}
						<div className="line"></div>
					</div>
					<div onClick={() => console.log(c)}></div>
					{c?.length ? (
						<div className="right">
							<div className="series">
								<h3>추천 포켓</h3>
								<div className="series-list">
									{c?.length ? (
										c.slice(0, 3).map((item, key) => (
											<div className="list" key={key}>
												<Link to={`/blog/series/${item.key}`}>
													<div
														className="seriesimg"
														style={{
															backgroundImage: `url(${shuffle[key]?.moThumbnail})`,
														}}
													></div>
													<div className="text-box">
														<h4>{item?.title}</h4>
														<p>게시글 {item?.value}개</p>
													</div>
												</Link>
											</div>
										))
									) : (
										<></>
									)}
								</div>
							</div>
							<div className="tag">
								<h3>최근 가장 인기있는 태그</h3>
								<ul>
									{tags.map((item, key) => (
										<Link to={`/tag/${item?.value?.name}`}>
											<li key={key}>#{item?.value?.name}</li>
										</Link>
									))}
								</ul>
							</div>
						</div>
					) : (
						<SkeletonSeriesWrap />
					)}
				</div>

				<BannerWrapper>
					{seriesNum?.length ? (
						<div
							className="banner"
							style={{ backgroundImage: `url(/images/banner-img02.png)` }}
						>
							<p className="title">
								새로운 금융IT 세상을 만들어갈 인재를 모십니다.
							</p>
							<a href="https://kbds.career.greetinghr.com/" target="_blank">
								<span>
									채용공고 보러가기
									<img src="/images/icon-banner-more.svg" alt="" />
								</span>
							</a>
						</div>
					) : (
						<SkeletonBanner />
					)}
				</BannerWrapper>
			</Wrapper>
		</Layout>
	);
};

export default Pocket;
